/**
 *  Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein.
 */

import { createStore } from 'vuex';
import axios from 'axios';
import { forIn } from 'lodash';

/**
 * decode HTML
 * @param {html} html html value.
 * @returns {string} Return string value.
 */
function decodeHTML(html) {
  let decodedObject = html;
  if (typeof decodedObject === 'string') {
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    decodedObject = JSON.parse(txt.value);
  }
  return decodedObject;
}

const getInitialQuestion = window.GuidedProductFinderAPIRoutes.start + '?quizid=';
const getQuestion = window.GuidedProductFinderAPIRoutes.getquestion + '?qid=';
const getNextQuestion = window.GuidedProductFinderAPIRoutes.submitquestion;
const getAssetBody = window.GuidedProductFinderAPIRoutes.getassetbody + '?';
const getAsset = window.GuidedProductFinderAPIRoutes.getasset + '?';

/**
 * Global Constants for defining API endpoints
 *
 */

export function getVuexStore() {
  return createStore({
    state: {
      jsonLoading: true,
      smallLoading: false,
      errorShow: false,
      errorMessage: 'Something went wrong!',
      externalUrl: '',
      category: '',
      quickview: '',
      quizData: null,
      questionData: null,
      stepData: null,
      visibleAnswers: {},
      showLandingPage: false,
      showEndPage: false,
      showPrivatePage: false,
      nextDisabled: true,
      welcomeHTML: '',
      endHTML: '',
      privateHTML: '',
      showProductsJSON: '',
      showProductsPage: false,
      showRecomms: false,
      showRecommendations: false,
      showproductscarousel: [],
      isSFRA: false,
      showQuiz: true,
      isAnswerMax: false,
      isHidden: true,
      contentAsset: '',
    },
    mutations: {
      setWelcomeHTML(state, data) {
        state.welcomeHTML = data;
      },
      setEndHTML(state, data) {
        state.endHTML = data;
      },
      setShowProductsJSON(state, data) {
        state.showProductsJSON = data;
      },
      setPrivateHTML(state, data) {
        state.privateHTML = data;
      },
      setJSONLoading(state, loading) {
        state.jsonLoading = loading;
      },
      setSmallLoading(state, loading) {
        state.smallLoading = loading;
      },
      setErrorShow(state) {
        state.errorShow = true;
      },
      setErrorMessage(state, error) {
        state.errorMessage = error;
      },
      setExternalUrl(state, url) {
        state.externalUrl = url;
      },
      setCategory(state, url) {
        state.category = url;
      },
      setQuickView(state, url) {
        state.quickview = url;
      },
      setShowProductsCarousel(state, data) {
        state.showproductscarousel = data;
      },
      setShowRecommendations(state, show) {
        state.showRecommendations = show;
      },
      setProductRecommendationsMessage(state, show) {
        state.productRecommendationsMessage = show;
      },
      setQuiz(state, data) {
        state.quizData = data;
        state.errorMessage = data.translations.generalError;
      },
      setAnswerValue(state, data) {
        const answers = state.questionData.answers;
        answers[0].value = data[1];
      },
      setQuestion(state, data) {
        const isAlreadyAnswered =
          data.questionData.userAnswer.length > 0 && data.questionData.userAnswer[0] !== '';
        forIn(data.questionData.answers, function (answer) {
          answer.selected = isAlreadyAnswered ? false : answer.isDefaultAnswer || false;
          answer.disabled = false;
          answer.hovered = false;
        });

        state.nextDisabled = true;
        const visibleAnswers = state.visibleAnswers[data.questionData.id];

        if (visibleAnswers) {
          const filteredAnswers = data.questionData.answers.filter(answer =>
            visibleAnswers.includes(answer.id)
          );
          data.questionData.answers = filteredAnswers;
        }

        if (isAlreadyAnswered) {
          const answers = data.questionData.answers;
          const answerDisabled = data.questionData.showAnswersAsDisabled;
          const answersMax = data.questionData.maxAnswers;
          const userAnswers = data.questionData.userAnswer;

          forIn(userAnswers, function (userAnswer) {
            const matchIndex = answers.map(ans => ans.id).indexOf(userAnswer);
            if (matchIndex >= 0) {
              data.questionData.answers[matchIndex].selected = true;
              state.nextDisabled = false;
            }
          });

          if (userAnswers.length == answersMax) {
            forIn(data.questionData.answers, function (answer, index) {
              if (answerDisabled && !answer.selected) {
                data.questionData.answers[index].disabled = true;
              }
            });
          }
        }

        state.questionData = data.questionData;
        state.stepData = data.stepData;
      },
      setVisibleAnswers(state, data) {
        state.visibleAnswers[data.questionID] = data.answers;
      },
      setWelcome(state, show) {
        state.showLandingPage = show;
      },
      setEnd(state, show) {
        state.showEndPage = show;
      },
      setPrivate(state, show) {
        state.showPrivatePage = show;
      },
      setShowProducts(state, show) {
        state.showProductsPage = show;
      },
      setNextButtonState(state, status) {
        state.nextDisabled = status;
      },
      setHover(state, d) {
        const answers = state.questionData.answers;
        const hoveredAnswer = answers[answers.map(ans => ans.id).indexOf(d[0].aid)];

        forIn(answers, function (answer) {
          answer.hovered = false;
        });

        hoveredAnswer.hovered = d[0].hover;
      },
      setAnswer(state, aid) {
        const answers = state.questionData.answers;
        const answerType = state.questionData.type;
        const answerDisabled = state.questionData.showAnswersAsDisabled;
        const answersMin = state.questionData.minAnswers;
        const answersMax = state.questionData.maxAnswers;
        const answerIndex = answers.map(ans => ans.id).indexOf(aid);
        const currentAnswer = answers[answerIndex];

        if (answerType === 'single') {
          if (!currentAnswer.selected) {
            forIn(answers, function (answer) {
              answer.selected = false;
            });
            currentAnswer.selected = true;
            state.nextDisabled = false;
          }
        }

        if (answerType === 'multiple') {
          let selectedAnswers = 0;
          forIn(answers, function (answer) {
            if (answer.selected == true) {
              selectedAnswers += 1;
            }
          });

          if (!currentAnswer.selected && selectedAnswers < answersMax) {
            currentAnswer.selected = true;
          } else if (currentAnswer.selected) {
            currentAnswer.selected = false;
          }

          selectedAnswers = 0;
          forIn(answers, function (answer) {
            if (answer.selected == true) {
              selectedAnswers += 1;
            }
          });

          if (selectedAnswers >= answersMin && selectedAnswers <= answersMax) {
            state.nextDisabled = false;
          } else {
            state.nextDisabled = true;
          }

          if (selectedAnswers === answersMax && state.quizData.accordionGoToNextQuestion === true) {
            state.isAnswerMax = true;
          } else {
            state.isAnswerMax = false;
          }

          if (selectedAnswers == answersMax && answerDisabled) {
            forIn(answers, function (answer) {
              if (!answer.selected) {
                answer.disabled = true;
              }
            });
          } else {
            forIn(answers, function (answer) {
              if (!answer.selected) {
                answer.disabled = false;
              }
            });
          }
        }
      },
      setShowQuiz(state, show) {
        state.showQuiz = show;
      },
      setContentAssetHTML(state, data) {
        state.contentAsset = data;
      },
      setStepData(state, data) {
        state.stepData = data;
      },
    },
    actions: {
      loadInitialQuestion(context, { qid, reset }) {
        let url = '';

        if (reset) {
          url = getInitialQuestion + qid + '&reset=true';
          context.commit('setJSONLoading', true);
        } else {
          url = getInitialQuestion + qid;
        }

        context.commit('setShowRecommendations', false);

        axios
          .get(url)
          .then(response => {
            response.data = decodeHTML(response.data);
            if (response.data.invalidlicense == true) {
              context.commit('setJSONLoading', false);
              context.commit('setErrorMessage', response.data.invalidlicenseText);
              context.commit('setErrorShow', true);
            }
            if (response.data.private == true) {
              let http = new XMLHttpRequest();
              let url = getAssetBody;
              let params = 'assetID=' + response.data.asset;
              http.open('POST', url, true);
              http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
              http.onreadystatechange = function () {
                if (http.readyState == 4 && http.status == 200) {
                  context.commit('setPrivateHTML', this.responseText);
                  context.commit('setPrivate', true);
                  context.commit('setJSONLoading', false);
                }
              };
              http.send(params);
            } else if (response.data.quizData.quizVisibleForCustomer === false) {
              context.commit('setJSONLoading', false);
              context.commit('setShowQuiz', false);
            } else if (response.data.quizData.quizVisibleForCustomer === true) {
              const res = response.data;
              const qData = res.quizData;
              const stepData = res.stepData;

              context.commit('setQuiz', qData);
              context.commit('setQuestion', res);
              if (res.questionData.renderTemplate === 'Template9') {
                let contentAsset = res.questionData.modalContent;
                let http = new XMLHttpRequest();
                let url = getAssetBody;
                let params = 'assetID=' + contentAsset;
                http.open('POST', url, true);
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                http.onreadystatechange = function () {
                  if (http.readyState == 4 && http.status == 200) {
                    context.commit('setContentAssetHTML', this.responseText);
                  }
                };
                http.send(params);
              }

              if (res.quizData.lastAnsweredQuestionID !== '' && qData.type === 'directional') {
                let nextStepIndex =
                  stepData.titles.map(item => item.id).indexOf(qData.lastAnsweredQuestionID) + 1;
                let stepLength = stepData.total - 1;

                if (nextStepIndex > stepLength) {
                  nextStepIndex = stepLength;
                }

                axios
                  .get(getQuestion + stepData.titles[nextStepIndex].id)
                  .then(resp => {
                    resp.data = decodeHTML(resp.data);
                    context.commit('setQuestion', resp.data);
                    context
                      .dispatch('preloadImages', {
                        quizImages: null,
                        questionImage: response.data.questionData.image,
                        answersImages: response.data.questionData.answers,
                      })
                      .then(() => {
                        context.commit('setJSONLoading', false);
                      });
                  })
                  .catch(() => {
                    context.commit('setJSONLoading', false);
                    context.commit('setErrorShow', true);
                  });
              } else {
                if (qData.showLandingPage && qData.showLandingPage.trim() !== '') {
                  context.commit('setWelcome', true);
                  let http = new XMLHttpRequest();
                  let url = getAsset;
                  let params = 'assetID=' + qData.showLandingPage;
                  http.open('POST', url, true);
                  http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                  http.onreadystatechange = function () {
                    if (http.readyState == 4 && http.status == 200) {
                      const data = decodeHTML(this.response);
                      context.commit('setWelcomeHTML', data);
                      if (res.questionData.renderTemplate === 'Template9') {
                        let contentAsset = res.questionData.modalContent;
                        let httpInner = new XMLHttpRequest();
                        let urlInner = getAssetBody;
                        let paramsInner = 'assetID=' + contentAsset;
                        httpInner.open('POST', urlInner, true);
                        httpInner.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                        httpInner.onreadystatechange = function () {
                          if (httpInner.readyState == 4 && httpInner.status == 200) {
                            context.commit('setContentAssetHTML', this.responseText);
                          }
                        };
                        httpInner.send(paramsInner);
                      }
                    }
                  };
                  http.send(params);
                }

                context
                  .dispatch('preloadImages', {
                    quizImages: res.quizData.images,
                    questionImage: res.questionData.image,
                    answersImages: res.questionData.answers,
                  })
                  .then(() => {
                    context.commit('setJSONLoading', false);
                  });
              }
            }
          })
          .catch(() => {
            context.commit('setJSONLoading', false);
            context.commit('setErrorShow', true);
          });
      },

      preloadImages(context, { quizImages, questionImage, answersImages }) {
        return new Promise(resolve => {
          const imagesToPreload = [];

          if (quizImages) {
            forIn(quizImages, function (image) {
              if (image != '') {
                imagesToPreload.push(image);
              }
            });
          }

          if (questionImage && questionImage != '') {
            imagesToPreload.push(questionImage);
          }

          if (answersImages.length > 0) {
            forIn(answersImages, function (answer) {
              if (answer.image != '') {
                imagesToPreload.push(answer.image);
              }
            });
          }

          const imagesLength = imagesToPreload.length;
          let imagesLoaded = 0;

          if (imagesLength > 0) {
            forIn(imagesToPreload, function (image) {
              const img = new Image();
              img.src = image;
              img.onload = function () {
                imagesLoaded += 1;
                if (imagesLoaded === imagesLength) {
                  resolve();
                }
              };
              img.onerror = function () {
                imagesLoaded += 1;
                if (imagesLoaded === imagesLength) {
                  resolve();
                }
              };
            });
          } else {
            resolve();
          }
        });
      },

      gotoQuestion(context, qid) {
        context.commit('setSmallLoading', true);
        context.commit('setShowRecommendations', false);
        context.commit('setShowProductsCarousel', []);
        axios
          .get(getQuestion + qid)
          .then(response => {
            response.data = decodeHTML(response.data);
            context.commit('setQuestion', response.data);
            context
              .dispatch('preloadImages', {
                quizImages: null,
                questionImage: response.data.questionData.image,
                answersImages: response.data.questionData.answers,
              })
              .then(() => {
                context.commit('setSmallLoading', false);
              });
          })
          .catch(() => {
            context.commit('setSmallLoading', false);
            context.commit('setErrorShow', true);
          });
      },

      prevQuestion(context, qid) {
        context.commit('setSmallLoading', true);

        axios
          .get(getQuestion + qid)
          .then(response => {
            response.data = decodeHTML(response.data);
            context.commit('setQuestion', response.data);
            context
              .dispatch('preloadImages', {
                quizImages: null,
                questionImage: response.data.questionData.image,
                answersImages: response.data.questionData.answers,
              })
              .then(() => {
                context.commit('setSmallLoading', false);
              });
          })
          .catch(() => {
            context.commit('setSmallLoading', false);
            context.commit('setErrorShow', true);
          });
      },

      submitQuestion(context, data) {
        context.commit('setSmallLoading', true);
        let http;
        let url;
        let params;
        const isSFRA =
          document.getElementById('guided-product-site') &&
          document.getElementById('guided-product-site').dataset.isSfra;
        data.isSFRA = isSFRA;
        axios
          .post(getNextQuestion, data)
          .then(response => {
            response.data = decodeHTML(response.data);
            let res = response.data;
            let template;
            if (res.action != null && res.action === 'end') {
              template = 'osfquizend';
              if (res.actionData && res.actionData != '') {
                template = res.actionData;
              }

              http = new XMLHttpRequest();
              url = getAssetBody;
              params = 'assetID=' + template;
              http.open('POST', url, true);
              http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
              http.onreadystatechange = function () {
                if (http.readyState == 4 && http.status == 200) {
                  context.commit('setEndHTML', this.responseText);
                  context.commit('setEnd', true);
                  context.commit('setSmallLoading', false);
                }
              };
              http.send(params);
            } else if (res.action != null && res.action === 'showproducts') {
              if (res.stepData) {
                context.commit('setStepData', res.stepData);
              }
              if (res.productRecommendationsMessage && !res.noProducts) {
                context.commit('setProductRecommendationsMessage', res.productRecommendationsMessage);
              } else {
                context.commit('setProductRecommendationsMessage', null);
              }
              if (!res.quizInlineResults) {
                window.location.assign(res.url);
              } else if (res.noProducts) {
                context.commit('setJSONLoading', false);
                context.commit('setShowRecommendations', true);
                context.commit('setShowProductsCarousel', []);
              } else {
                context.commit('setJSONLoading', false);
                context.commit('setShowRecommendations', false);
                context.commit('setShowProductsCarousel', res.actionData);
              }
            } else if (res.action != null && res.action === 'product' && res.actionData !== '') {
              if (!res.quizInlineResults) {
                window.location.assign(res.actionData);
              } else {
                context.commit('setJSONLoading', false);
                context.commit('setQuickView', res.actionData);
              }
            } else if (res.action != null && res.action === 'category' && res.actionData !== '') {
              if (!res.quizInlineResults) {
                window.location.assign(res.actionData);
              } else if (isSFRA === 'true') {
                axios.get(res.actionData).then(() => {
                  context.commit('setJSONLoading', false);
                  context.commit('setCategory', res.actionData);
                });
              } else {
                context.commit('setJSONLoading', false);
                context.commit('setCategory', res.actionData);
              }
            } else if (res.action != null && res.action === 'redirect' && res.actionData != '') {
              window.location.assign(res.actionData);
            } else if (res.action != null && res.action === 'externalurl' && res.actionData != '') {
              if (!res.quizInlineResults) {
                window.location.assign(res.actionData);
              } else {
                context.commit('setJSONLoading', false);
                context.commit('setExternalUrl', res.actionData);
              }
            } else if (res.action != null && res.action === 'submitanswers' && res.actionData != '') {
              window.location.assign(res.actionData);
            } else {
              const questionID = res.questionData.id;
              const answers = res.questionData.answers.map(el => el.id);
              context.commit('setVisibleAnswers', {
                questionID,
                answers,
              });
              context.commit('setQuestion', res);
              if (res.questionData.renderTemplate === 'Template9') {
                let contentAsset = res.questionData.modalContent;
                http = new XMLHttpRequest();
                url = getAssetBody;
                params = 'assetID=' + contentAsset;
                http.open('POST', url, true);
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                http.onreadystatechange = function () {
                  if (http.readyState == 4 && http.status == 200) {
                    context.commit('setContentAssetHTML', this.responseText);
                  }
                };
                http.send(params);
              }
              context
                .dispatch('preloadImages', {
                  quizImages: null,
                  questionImage: res.questionData.image,
                  answersImages: res.questionData.answers,
                })
                .then(() => {
                  context.commit('setSmallLoading', false);
                });
            }
          })
          .catch(() => {
            context.commit('setSmallLoading', false);
            context.commit('setErrorShow', true);
          });
      },
    },
  });
}
